export * from './components/Loading';

const ActivityIndicator = {
  timer: null as number | null,
  showLoading() {
    Mach.sendEvent('onMachActivityIndicatorChange', true);
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.hideLoading();
    }, 25000);
  },
  hideLoading: () => {
    Mach.sendEvent('onMachActivityIndicatorChange', false);
  },
};

export default ActivityIndicator;
